// Окно «Пригласить друзей»: ссылка, ник, кто зарегистрировался и что начислено. Подписи и значения приходят с сервера
// готовыми (GET /api/me/referrals): набор данных зависит от учётной записи и решается только там, здесь - общее отображение.
import { useEffect, useState, type ReactNode } from 'react';
import type { DialogProps } from '../../core/registry';
import { api } from '../../core/api';
import { Btn, Modal } from '../../ui/controls';
import { Icon } from '../../ui/icons';
import { CopyField } from '../admin/common';

export interface ViewColumn { key: string; label: string; type?: 'date' | 'num' }
export interface ViewTable { title?: string; columns: ViewColumn[]; rows: Record<string, any>[]; empty?: string; removable?: boolean }
export interface ViewItem { label: string; value: string | number }
interface RefView { nick: string; path: string; active: boolean; how: string; off: string; text: string; summary: ViewItem[]; tables: ViewTable[] }

const fmtDay = (ts: number) => new Date(ts * 1000).toLocaleDateString('ru-RU');

export function ViewSummary({ items }: { items: ViewItem[] }) {
  return (
    <div className="au-ref-summary" data-testid="ref-summary">
      {items.map((x) => <div key={x.label} className="au-ref-card"><div className="au-ref-value">{x.value}</div><div className="au-ref-label">{x.label}</div></div>)}
    </div>
  );
}

export function ViewTableBlock({ table, action, actionHead }: { table: ViewTable; action?: (row: Record<string, any>) => ReactNode; actionHead?: boolean }) {
  return (
    <>
      {table.title && <div className="au-ref-title">{table.title}</div>}
      <div className="adm-table-wrap">
        <table className="adm-table is-compact" data-testid="ref-table">
          <thead><tr>{table.columns.map((c) => <th key={c.key} className={c.type === 'num' ? 'num' : ''}>{c.label}</th>)}{(action || actionHead) && <th className="adm-col-act" />}</tr></thead>
          <tbody>
            {table.rows.map((r, i) => (
              <tr key={r._id ?? i} data-testid="ref-row">
                {table.columns.map((c) => <td key={c.key} className={c.type === 'num' ? 'num' : ''}>{c.type === 'date' ? (r[c.key] ? fmtDay(r[c.key]) : '—') : (r[c.key] === '' || r[c.key] === undefined ? '—' : r[c.key])}</td>)}
                {action && <td className="adm-col-act adm-actions">{action(r)}</td>}
              </tr>
            ))}
          </tbody>
        </table>
        {!table.rows.length && <div className="adm-empty"><Icon name="users" size={26} /><div>{table.empty}</div></div>}
      </div>
    </>
  );
}

export function ReferralsDialog({ close }: DialogProps) {
  const [view, setView] = useState<RefView | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => { api.get<RefView>('/api/me/referrals').then(setView).catch((e) => setErr(e.message)); }, []);
  return (
    <Modal title="Пригласить друзей" onClose={() => close()} width={720} testid="ref-dialog" footer={<Btn label="Закрыть" onClick={() => close()} />}>
      {view && <>
        <p data-testid="ref-text">{view.text}</p>
        {view.active
          ? <>
            <CopyField value={location.origin + view.path} testid="ref-link" />
            <p className="au-muted small">{view.how} Ваш ник: <b data-testid="ref-nick">{view.nick}</b></p>
          </>
          : <p className="au-ref-off" data-testid="ref-off"><Icon name="info" size={15} /> {view.off}</p>}
        <ViewSummary items={view.summary} />
        {view.tables.map((t, i) => <ViewTableBlock key={i} table={t} />)}
      </>}
      {err && <div className="au-error" role="alert"><Icon name="error" size={16} /><span>{err}</span></div>}
    </Modal>
  );
}
